@if (navigationSignal().length) {
<nav class="breadcrumb-container" aria-label="breadcrumb">
  <ol class="breadcrumb-rng   breadcrumb-list-rng d-flex align-items-center">
    @for ( navigation of navigationSignal(); track $index) {
    @if (!navigation.breadcrumb.isActive) {
    <li class="breadcrumb-item-rng">
      <a class="text-decoration-none" role="button" (click)="navigateTo(navigation.route,navigation.queryParams)">{{
        navigation.breadcrumb.breadcrumbName}} </a>
    </li>
    }
    @if (navigation.breadcrumb.isActive) {
    <li class="breadcrumb-item-rng active-rng" aria-current="page">
      {{navigation.breadcrumb.breadcrumbName}}</li>
    }

    @if (navigationSignal().length > $index + 1) {
    <span> / </span>
    }

    @if ($index == navigationSignal().length - 1 && navigation.canGoBack) {
    <li class="ms-auto">
      <button mat-button color="primary" (click)="onBack()"><mat-icon>arrow_back_ios</mat-icon>
        Back</button>
    </li>
    }
    }
  </ol>
</nav>
}